import { useState } from "react";
import {
    CoverageActionKey,
    CoverageToolsPageProps,
    FormularyLookupPageProps,
    FormularyTierPageProps,
    MailOrderPricesPageProps,
    PharmacyLocationSearchPageProps,
} from "./types";
import GuestLayout from "@Core/Layouts/GuestLayout";
import { CoverageToolPageLayout } from "./Components";
import {
    PharmacyLocationSearchPage,
    FormularyLookupPage,
    FormularyTierPage,
    MailOrderPricesPage,
} from "./Pages";
import { PrivatePharmacyDisclaimer } from "./Components/MailOrderPrices";

function resolvePage(action: CoverageActionKey, props: CoverageToolsPageProps) {
    switch (action) {
        case "FORMULARY_LOOKUP":
            return (
                <FormularyLookupPage {...(props as FormularyLookupPageProps)} />
            );

        case "PHARMACY_LOCATION_SEARCH":
            return (
                <PharmacyLocationSearchPage
                    {...(props as PharmacyLocationSearchPageProps)}
                />
            );

        case "FORMULARY_TIER":
            return <FormularyTierPage {...(props as FormularyTierPageProps)} />;

        case "MAIL_ORDER_PRICES":
            return (
                <MailOrderPricesPage {...(props as MailOrderPricesPageProps)} />
            );

        default:
            return null;
    }
}
const Index = (props: CoverageToolsPageProps) => {
    const [action, setAction] = useState<CoverageActionKey>(
        props.pageState?.action ?? "NONE",
    );
    const page = resolvePage(action, props);

    return (
        <CoverageToolPageLayout
            action={action}
            onActionChange={(action) => setAction(action)}
            header={
                action === "MAIL_ORDER_PRICES" ? (
                    <PrivatePharmacyDisclaimer />
                ) : null
            }
        >
            {page}
        </CoverageToolPageLayout>
    );
};

Index.layout = (page: JSX.Element) => (
    <GuestLayout
        title="Formulary List | Sav-Rx"
        hideContainer={true}
        children={page}
    />
);

export default Index;
